GP.collections.ChatUsers = Backbone.Collection.extend({
    model: GP.models.User,

    sortColumns:    ['gender','username'],
    sortDirections: ['desc',  'asc'],

    changeSortOrder: function(gender) {
        if (!gender || gender.toLowerCase() == 'woman') {
            this.sortDirections = ['desc','asc'];
        } else if (gender.toLowerCase() == 'man') {
            this.sortDirections = ['asc','asc'];
        }
    },

    comparator: function(a, b) {
        // First column that does not have equal values
        var cmp = _.find(this.sortColumns, function(c) {
            return a.attributes[c] != b.attributes[c];
        });

        // undefined means they're all equal, so we're done.
        if (!cmp) {
            return 0;
        }

        // Otherwise, use that column to determine the order
        // match the column sequence to the methods for ascending/descending
        // default to ascending when not defined.
        if ((this.sortDirections[_.indexOf(this.sortColumns, cmp)] || 'asc').toLowerCase() == 'asc') {
            return a.attributes[cmp].toLowerCase() > b.attributes[cmp].toLowerCase() ? 1 : -1;
        } else {
            return a.attributes[cmp].toLowerCase() < b.attributes[cmp].toLowerCase() ? 1 : -1;
        }
    }
});
